package fyi.moko.hotpl.domain.model

/**
 * A computed (not stored) answer to "is now a good window to revisit this place?",
 * derived from the place's [RevisitCadence], last visit, and visit count.
 *
 * Pure value — no platform references. Produced by
 * [fyi.moko.hotpl.domain.usecase.RevisitWindowCalculator], which is the single
 * place that knows the cadence→threshold mapping so the rule is judged in
 * isolation before any UI depends on it.
 *
 * @property isGoodNow True when "now" falls inside the revisit window for this
 *   place's cadence and the place has not been visited too recently (the
 *   "경고보다 맥락" guardrail — quietly exclude over-visited places rather than
 *   warning the user).
 * @property daysUntilWindow Days until the next window opens, or 0 when
 *   [isGoodNow] is true. Negative means the window has been open for that many
 *   days (still good). Null when the cadence is [RevisitCadence.ANYTIME] — there
 *   is no window to count down to.
 * @property reason A short, deterministic label for why this window is (or is
 *   not) open. Intended for diagnostics and future UI hints, not user-facing
 *   copy (phrasing lives in the UI layer, like VisitPhrasing).
 */
data class RevisitWindow(
    val isGoodNow: Boolean,
    val daysUntilWindow: Int?,
    val reason: String,
)